import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* global crypto */
export function sha256(_x) {
  return _sha.apply(this, arguments);
}

function _sha() {
  _sha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
    var msgBuffer, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // encode as UTF-8
            msgBuffer = new TextEncoder('utf-8').encode(message); // hash the message

            _context.next = 3;
            return crypto.subtle.digest('SHA-256', msgBuffer);

          case 3:
            hashBuffer = _context.sent;
            // convert ArrayBuffer to Array
            hashArray = Array.from(new Uint8Array(hashBuffer)); // convert bytes to hex string

            hashHex = hashArray.map(function (b) {
              return ('00' + b.toString(16)).slice(-2);
            }).join('');
            return _context.abrupt("return", hashHex);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sha.apply(this, arguments);
}